import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['finance'], // 为了获取基础路由
    };
};
export const financeToPathNameMap = {
    // 跳转订单详情
    finance8004: ({ businessKey }) => commonFunc(`/insuranceOrder/detail?bizId=${businessKey}`),
    finance8005: ({ businessKey }) => commonFunc(`/insuranceOrder/detail?bizId=${businessKey}&openDealTypeMessageDrawer=1`),
    finance8010: ({ businessKey }) => commonFunc(`/financeOrder/detail?id=${businessKey}`),
    finance7100: () => commonFunc(`/financeOrder`),
};
